module.exports = __webpack_public_path__ + "img/search-bg-icon.c46e6e69.png";